import { NSMenuActionProps } from "namirasoft-site-react";
import { AccessProps } from "./AccessProps";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PermissionRow } from "namirasoft-access";

export class AccessMenus
{
	static switchToMyOwn(props: NSARouterMakerResult & AccessProps): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "To My Own",
			isActive: () =>
			{
				return true;
			},
			onClick: {
				action: (onFinished) =>
				{
					props.servers.access.access.SetOwner({ owner_id: null }).then(() =>
					{
						props.notifier.onSuccess(`You have successfully switched to your own user.`);
						props.notifier.onSuccess(`Refreshing the page ...`, 2000);
						setTimeout(() =>
						{
							window.location.reload();
							onFinished();
						}, 2000);
					}).catch(onFinished);
				}
			}
		}
	}
	static switchToUser(props: NSARouterMakerResult & AccessProps, getIDs: () => string[], getRows: () => PermissionRow[]): NSMenuActionProps
	{
		return {
			id: "2",
			menu_item: "To This User",
			isActive: () =>
			{
				return getIDs().length === 1;
			},
			onClick: {
				action: (onFinished) =>
				{
					let permission = getRows()[0];
					props.servers.access.access.SetOwner({ owner_id: permission.user_id }).then(() =>
					{
						props.notifier.onSuccess(`You have successfully switched to user '${(permission.from_first_name + " " + permission.from_last_name).trim()}'.`);
						props.notifier.onSuccess(`Refreshing the page ...`, 2000);
						setTimeout(() =>
						{
							window.location.reload();
							onFinished();
						}, 2000);
					}).catch(onFinished);
				}
			}
		}
	}
}